import { Injectable } from '@angular/core';
import { PersonType } from '../../../common/common/constants/person-type.enum';
import { WorkItemTypes } from '../../../common/workitems/constants/workitem-types';
import * as moment from 'moment';
import { OperatorStatus } from 'components/queue-view/live-workload-tab/models/operator-status';

@Injectable()
export class BackendFieldConverterService {

  public personTypeConverter(personType: PersonType): string | PersonType {
    switch (personType) {
      case PersonType.Operator:
      case PersonType.OperatorTranslated:
        return 'queueViewTab.personTypes.operator';
      case PersonType.Visitor:
      case PersonType.VisitorTranslated:
        return 'queueViewTab.personTypes.visitor';
      case PersonType.System:
        return 'queueViewTab.personTypes.system';
      default:
        return personType;
    }
  }

  public convertMessagingType(type: number): WorkItemTypes {
    switch (type) {
      case 0:
        return WorkItemTypes.SMS;
      case 1:
        return WorkItemTypes.FACEBOOK;
      case 3:
        return WorkItemTypes.ASYNC_MESSAGE;
      default:
        throw Error('Invalid messaging type');
    }
  }

  public convertEndedReasonType(type: number): string {
    switch (type) {
      case 0:
        return 'bcVisitorInfo.unknown';
      case 1:
        return 'bcVisitorInfo.agent';
      case 2:
        return 'bcVisitorInfo.customer';
      case 3:
        return 'bcVisitorInfo.disconnect';
      case 4:
        return 'bcVisitorInfo.botTimeout';
      case 5:
        return 'bcVisitorInfo.autoEndInterval';
      default:
        return '';
    }
  }

  public dateFormatter(value: string): string {
    if (value) {
      if (isNaN(Number(value))) {
        return moment(value).calendar(null, { sameElse: 'llll' });
      }
      return moment(Number(value)).calendar(null, { sameElse: 'llll' });
    }
    return value;
  }

  public isoDateFormatter(value: string): string {
    if (value) {
      if (isNaN(Number(value))) {
        return moment(value).utc().format();
      }
      return moment(Number(value)).utc().format();
    }
    return value;
  }

  public convertClientType(type: number): string {
    switch (type) {
      case 0:
        return 'bcVisitorInfo.desktop';
      case 2:
        return 'bcVisitorInfo.mobile';
      default:
        return '';
    }
  }

  public chatTypeConverter(chatType: number): WorkItemTypes {
    switch (chatType) {
      case 0:
        return WorkItemTypes.SMS;
      case 1:
        return WorkItemTypes.FACEBOOK;
      case 3:
        return WorkItemTypes.ASYNC_MESSAGE;
      default:
        return '';
    }
  }

  public statusTypeConverter(statusType: number): OperatorStatus | '' {
    switch (statusType) {
      case 0:
        return OperatorStatus.OFFLINE;
      case 1:
        return OperatorStatus.AWAY;
      case 2:
        return OperatorStatus.AVAILABLE;
      default:
        return '';
    }
  }

  public serviceTypeConverter(serviceType: string): string {
    switch (serviceType) {
      case '1':
        return 'CHAT';
      case '3':
        return 'EMAIL';
      case '9':
        return 'SMS';
      case '13':
        return 'FACEBOOK';
      case '15':
        return 'ASYNC_MESSAGE';
      case '16':
        return 'OMNI';
      default:
        return serviceType;
    }
  }
}
